webpackJsonp([1],{

/***/ "+A8q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello uk-container"},[(_vm.showResults)?_c('div',{staticClass:"uk-text-center"},[_c('h3',[_vm._v("Quiz Completed")]),_vm._v(" "),_c('h4',[_vm._v("Score: "+_vm._s(_vm.numberCorrect / _vm.total * 100)+"% ( "+_vm._s(_vm.numberCorrect)+" of 20 correct )")]),_vm._v(" "),_c('p',{staticClass:"uk-margin-large"},[_c('button',{staticClass:"uk-button uk-button-default",on:{"click":function($event){return _vm.reset()}}},[_vm._v("Try again")])]),_vm._v(" "),_c('p',{staticClass:"uk-margin-large"},[_c('button',{staticClass:"uk-button uk-button-default",on:{"click":function($event){return _vm.startReview()}}},[_vm._v("Review Answers")])])]):_c('div',[_c('div',[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},_vm._l((_vm.questions),function(question,index){return (index == _vm.current)?_c('div',{key:index},[_c('div',{attrs:{"uk-grid":""}},[_c('div',{staticClass:"uk-width-1-4"},[_c('h4',[_vm._v("Question "+_vm._s(_vm.current + 1)+" of "+_vm._s(_vm.total))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.stem(question)))]),_vm._v(" "),_vm._l((question.randomChoices),function(answer){return _c('div',[(!_vm.reviewIncorrect)?_c('p',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.radioModels[index]),expression:"radioModels[index]"}],attrs:{"type":"radio","name":_vm.radioName(index)},domProps:{"value":answer,"checked":_vm._q(_vm.radioModels[index],answer)},on:{"click":function($event){return _vm.select(answer)},"change":function($event){return _vm.$set(_vm.radioModels, index, answer)}}}),_vm._v(" "+_vm._s(answer))])]):_c('p',[(question.choices[answer])?_c('span',{staticClass:"correct"},[_vm._v(_vm._s(answer)+" (Correct)")]):(question.selectedAnswer == answer)?_c('span',{staticClass:"wrong"},[_vm._v(_vm._s(answer)+" (Selected)")]):_c('span',[_vm._v(_vm._s(answer))])])])})],2),_vm._v(" "),_c('div',{staticClass:"uk-width-3-4",style:(_vm.frameStyle)},[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.imageUrl(question)}})])])]):_vm._e()}),0)],1),_vm._v(" "),_c('div',{staticClass:"uk-margin-large",attrs:{"uk-grid":""}},[_c('div',{staticClass:"uk-width-1-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.current > 0),expression:"current > 0"}],staticClass:"uk-button uk-button-default",on:{"click":function($event){return _vm.retreat()}}},[_vm._v("Previous")])]),_vm._v(" "),_c('div',{staticClass:"uk-width-1-2 uk-text-center"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:((_vm.current == _vm.total - 1 && _vm.radioModels[_vm.current] != '') || _vm.reviewIncorrect),expression:"(current == total - 1 && radioModels[current] != '') || reviewIncorrect"}],staticClass:"uk-button uk-button-default",on:{"click":function($event){return _vm.finish()}}},[_vm._v("Finish")])]),_vm._v(" "),_c('div',{staticClass:"uk-text-right uk-width-1-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.current < _vm.total - 1 && _vm.radioModels[_vm.current] != ''),expression:"current < total - 1 && radioModels[current] != ''"}],staticClass:"uk-button uk-button-default",on:{"click":function($event){return _vm.advance()}}},[_vm._v("Next")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CN7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LessonImage_vue__ = __webpack_require__("POcG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bd29ec6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LessonImage_vue__ = __webpack_require__("Hu4q");
function injectStyle (ssrContext) {
  __webpack_require__("Sg9n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bd29ec6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LessonImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bd29ec6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LessonImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GcBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-light",attrs:{"id":"app"}},[_c('nav',{staticClass:"uk-navbar uk-navbar-transparent"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"uk-navbar-right"},[_c('ul',{staticClass:"uk-navbar-nav"},[_c('li',[_c('router-link',{attrs:{"to":"lesson"}},[_vm._v("Guided Tour")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"quiz"}},[_vm._v("Quiz")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"reference"}},[_vm._v("Library")])],1)])])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-navbar-left"},[_c('div',{staticClass:"uk-navbar-item uk-logo"},[_vm._v("\n            Orthopedic Hardware Radiographs & Complications\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hu4q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"right","margin":"40px"}},[_c('div',{staticClass:"uk-inline"},[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.url}}),_vm._v(" "),_c('div',{staticClass:"uk-position-bottom-left",attrs:{"uk-parallax":"y: -100,0; viewport: 0;"}},[_c('div',{staticStyle:{"margin-left":"10px"}},[_vm._v("\n        "+_vm._s(_vm.caption)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IaEv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JKZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__ = __webpack_require__("qLo6");


// TOC

// Introduction
// Fixation: Conservative Measures, Internal Fixation
// Arthrodesis
// Arthroplasty: Shoulder, Hip, Knee, Ankle
// Hardware Failure: Dislocation, Hardware Fracture, Periprosthetic Fractures,
//   Heterotopic ossification, Osteolysis/Loosening
// Conclusion

/* harmony default export */ __webpack_exports__["a"] = ({
  sections: [{
    title: 'Fixation',
    text: '\n        <p>The goal of fixation is to reduce the distance between facture fragments and to stabilize\n          fracture fragments to facilitate healing and proper alignment. Additionally, fracture fixation\n        encourage early mobilization in the patient.</p>\n      ',
    subsections: [{
      title: 'Conservative Measures',
      slides: [{
        id: 'cast',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.cast.examples[0],
        text: '\n                <p>\n                  Conservative measures of fixation involves initial closed reduction and then stabalization\n                  splints, casts, or traction devices.\n                  A splint is often used for initial stablization prior to casting or internal fixation. The\n                  splint is adjustable and allows for swelling.\n                </p>\n                <p>\n                  On radiographs the splint material is more irregular and is often not circumferential.\n                </p>\n                ',
        textLayout: {
          pos: 'top-right',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'center-left',
          bg: false,
          w: 30
        }
      }, {
        id: 'splint',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.splint.examples[0],
        text: '',
        textLayout: {
          pos: 'bottom-right',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'top-right',
          bg: true,
          w: 50
        }
      }, {
        id: 'pin1',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.percutaneous_pin.examples[0],
        text: '\n                <p>Traction devices include Kirschner (K) wires and percutaneous pins. These are\n                placed along the axis of long bones and provide stablization without open surgery.\n                They can be easily removed when needed. An additional advantage of K wires\n                is that they are thin and smooth and wont damage the growth plates in children.</p>\n              ',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-right',
          bg: false,
          w: 50
        }
      }, {
        id: 'pin2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.percutaneous_pin.examples[1],
        text: '',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'center-left',
          bg: false,
          w: 20
        }
      }, {
        id: 'exfix',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.exfix.examples[0],
        text: '\n                <p>External fixation is used with extensive soft tissue injury or polytrauma. It is also used\n                temporarily before internal fixation and during arthrodesis. Frequent skin care for the external\n                pins to prevent infection and radiography to look for hardware failure are important.</p>\n                ',
        textLayout: {
          pos: 'top-right',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'center-right',
          bg: true,
          w: 25
        }
      }]
    }, {
      title: 'Internal Fixation',
      slides: [{
        id: 'platescrew',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.platescrew.examples[0],
        imgAlign: 'right',
        text: '\n                    <p>Open reduction and internal fixation is performed when a\n                closed option is not possible. This enables early mobilization and function\n                which promotes fast rehabiliation. There is a wide variety of internal\n                fixation hardware, which includes many types of pins, wires, screws, plates,\n                and rods with different indications.</p>\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 50
        }
      }, {
        id: 'screw',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.screws.examples[0],
        imgAlign: 'left',
        text: '\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'top-right',
          bg: false,
          w: 30
        }
      }, {
        id: 'screw2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.screws.examples[1],
        imgAlign: 'right',
        text: '\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 50
        }
      }, {
        id: 'spiral',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.spiral.examples[0],
        imgAlign: 'right',
        text: '\n                    <p >Compression can be static or\n                dynamic. Static compression is the compression provided by the hardware.\n                Dynamic compression utilizes the body\'s own motions to provide additional\n                compression. </p>\n\n                  <p>The spiral blade is typically used for an\n                    intertrochanteric fracture and allows for dynamic compression. Similarly\n                    used is the dynamic compression screw, which consists of a lag screw\n                    which fits in the barrel of a side plate. The side plate is fixed to the\n                    femur and the barrel allows the lag screw to move within it. Ambulation\n                    provides dynamic compression.</p>\n                ',
        textLayout: {
          pos: 'bottom-left',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'top-left',
          bg: true,
          w: 40
        }
      }, {
        id: 'dynamic',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.dynamic.examples[0],
        imgAlign: 'center',
        text: '\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'top-left',
          bg: true,
          w: 80
        }
      }, {
        id: 'imnail',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.imnail.examples[0],
        imgAlign: 'center',
        text: '\n                <p>Intramedullary nails are placed percutaneously.\n                These are thick rods that are used to stablize shaft fractures which are\n                not near joints against bending. Optional interlocking screws are often\n                places at the proximal and distal ends of the nail to prevent rotation\n                and shortening. Once some healing has occured the distal screws can be\n                removed to allow faster healing due to dynamic compression. </p>\n                ',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'imnail2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.imnail.examples[1],
        imgAlign: 'center',
        text: '\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 50
        }
      }, {
        id: 'hagie',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.hagie.examples[0],
        imgAlign: 'center',
        text: '\n                  <p>The Hagie pin is a type of partially threaded\n                intramedullary pin which has a threaded end to secure the distal fragment\n                and a nut optionally applied to the other end for compression, typically\n                used for clavicular fractures.</p>\n                ',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 60
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'cerclage',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.cerclage.examples[0],
        imgAlign: 'left',
        text: '\n                <p>Cerclage wires or cables (made of multiple wires) are\n                used in combination with other fixation hardware and they go around the bone\n                to hold fragments together.</p>\n                ',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'center-right',
          bg: false,
          w: 40
        }
      }, {
        id: 'tension',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.tension.examples[0],
        imgAlign: 'left',
        text: '\n                <p>The tension wire and K-wires are often used\n                for displaced fragments, typically in the patella and olecrenon. They\n                provide dynamic compression.</p>\n                ',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 80
        }
      }, {
        id: 'tension2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.tension.examples[1],
        imgAlign: 'center',
        text: '\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 50
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 50
        }
      }, {
        id: 'bladeplate',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.bladeplate.examples[0],
        imgAlign: 'center',
        text: '\n                <p>Blade plates have a fixed angle top and are\n                often used for subtrochanteric osteotomies or fractures. The blade\n                portion goes into the metaphysis.</p>\n                ',
        textLayout: {
          pos: 'top-right',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'top-left',
          bg: true,
          w: 40
        }
      }, {
        id: 'syndesmotic-screw',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.syndesmotic.examples[0],
        imgAlign: 'right',
        text: '\n                <!-- anchor screws --> <p>Anchor screws are used for tendon and ligament\n                repair. One end is inserted through the cortex of the bone and the other\n                end has an attachment site for suture material, which ties into the\n                ligament or tendon.</p>\n\n                <!-- syndesmotic screw --> <p>The syndesmotic screw spans the\n                tibiofibular syndesmosis. It may be placed in isolation or through a\n                plate. Be on the lookout for loosening as this is one of the most common\n                sites for this to occur, as there is a lot of motion. These are\n                typically removed after 6-12 weeks.</p>\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'top-right',
          bg: false,
          w: 40
        }
      }]
    }]
  }, {
    title: 'Arthrodesis',
    subsections: [{
      slides: [{
        id: 'arthrodesis',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.arthrodesis.examples[0],
        imgAlign: 'right',
        text: '\n                <p>Arthrodesis is the fusion of at least two bones. This is done to stop the progression of\n                  arthritic disease and alleviate pain. It is also used to correct deformities in the extremities,\n                  such as pes planus.</p>\n\n                  <!-- four corner -->\n                <p>The four corner arthrodesis is used in the case of scaphoid nonunion when the lunate is still\n                  healthy. It involves scaphoidectomy and fusion of the hamate, lunate, capitate and triquetrum.\n                  If there is lunate osteonecrosis, a proximal row carpectomy is preferred.</P>\n                ',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'top-right',
          bg: true,
          w: 40
        }
      }, {
        id: 'syndesmotic',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.arthrodesis.examples[1],
        imgAlign: 'right',
        text: '\n                <p>The triple arthrodesis is used for Chopard\'s joint <!-- spelling -->  (often involved in neuropathic joint) and\n                  to fix hindfoot or forefoot deformities such as pes planus. It involves fusion of the\n                  subtalar, calcaneocuboid, and talonavicular joints. </p>\n                ',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 30
        }
      }]
    }]
  }, {
    title: 'Arthroplasty',
    subsections: [{
      title: 'Shoulder',
      slides: [{
        id: 'resurfacing',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].shoulder.resurfacing.examples[0],
        imgAlign: 'right',
        text: '\n                <p>A hemiarthroplasty is used for fractures or avascular necrosis of the humeral head\n                   or rotator cuff tears. You can tell that the glenoid is intact because there is no metal there.</p>\n\n                <p>A resurfacing hemiarthroplasty is similar except only the humeral head is replaced. There is no stem.</p>\n                ',
        textLayout: {
          pos: 'bottom-right',
          bg: true,
          w: 50
        },
        caption: {
          pos: 'center-left',
          bg: true,
          w: 30
        }
      }, {
        id: 'totalshoulder1',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].shoulder.total.examples[0],
        imgAlign: 'left',
        text: '\n                <p>A conventional arthroplasty is used when there is no rotator cuff deficiency, such as arthritis.</p>\n                ',
        textLayout: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        },
        caption: {
          pos: 'top-right',
          bg: true,
          w: 40
        }
      }, {
        id: 'totalshoulder2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].shoulder.total.examples[1],
        imgAlign: 'center',
        text: '\n                ',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'reverse',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].shoulder.reverse.examples[0],
        imgAlign: 'left',
        text: '\n                  <p>A reverse total arthroplasty is used for rotator cuff tears or after failed conventional arthroplasty.\n                  This uses the deltoid muscle for action and is a good choice if there is rotator cuff deficiency.</P>\n\n                  <p>The glenoid componennt may be screwed or cemented and the humeral component may or may not be cemented.</p>\n                ',
        textLayout: {
          pos: 'center-right',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }]
    }, {
      title: 'Hip',
      slides: [{
        id: 'hip',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.unipolar.examples[0],
        imgAlign: 'right',
        text: '\n              <p>Indications for hip arthroplasty include: arthritis, infection, trauma, and avascular necrosis.</p>\n\n              <p>A unipolar hemiarthroplasty is used in patients with low life expectancy and only contains a femoral\n                component.</p>\n                ',
        textLayout: {
          pos: 'center-right',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'hip1',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.unipolar.examples[1],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'hip2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.bipolar.examples[0],
        imgAlign: 'left',
        text: '\n              <p>Bipolar hemiarthroplasty is used for patients with Garden 4 subcapital fractures\n                that have a preserved joint in order to manage the risk of avascular necrosis. It is less\n                prone to dislocation and damage to the native acetabular fossa. There is a femoral stem\n                and a femoral shell that snap together. There is no acetabular component. The femoral stem\n              can rotate within the shell and the shell within the acetabular. Since there are two mobile\n              components, there is less motion and less wear on the native acetabulum.\n              </p>',
        textLayout: {
          pos: 'top-left',
          bg: true,
          w: 30
        },
        caption: {
          pos: 'bottom-right',
          bg: true,
          w: 95
        }
      }, {
        id: 'hip3',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.bipolar.examples[1],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'hip4',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.total.examples[0],
        imgAlign: 'right',
        text: '\n              <p>Total arthroplasty is used for arthritis. There is a separate femoral and acetabular\n                component. Usually it is metal against polyethylene.</p>\n\n              <p>Cement may be used. If no cement is used a bioactive coating (hydroxyapetite) <!-- check --> or rough surface of the\n                hardware stimulates osseous growth. Screws may be used in the acetabular component. It\n                is most common to see a cemented femoral component and a non-cemented acetabular component.</p>\n            ',
        textLayout: {
          pos: 'top-right',
          bg: true,
          w: 30
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'hip5',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.total.examples[1],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-left',
          bg: false,
          w: 30
        }
      }, {
        id: 'hip6',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.spacer.examples[0],
        imgAlign: 'center',
        text: '<p>An articulating antibiotic spacer is often used with infected joints and may be mistaken for a\n                total hip arthroplasty. Look for thick cemented.</p>',
        textLayout: {
          pos: 'top-left',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 50
        }
      }]
    }, {
      title: 'Knee',
      slides: [{
        id: 'unicompartmental',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.unicompartmental.examples[0],
        imgAlign: 'left',
        text: '<p>Knee replacement is often for arthritis. Again, there are several different types.</p>\n\n              <p>A unicompartmental replacement is often done on the medial joint. There is a femoral\n                condyle component and a corresponding tibial component.</p>',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'unicompartmental1',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.unicompartmental.examples[1],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 30
        }
      }, {
        id: 'nostemtotal',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.nostemtotal.examples[0],
        imgAlign: 'right',
        text: '<p>A total knee arthroplasty involves resurfacing of all three joint compartments. The\n                components may have no stem, a short stem, or a long stem. Cement may also be used.\n              With increasing bone loss nad more revisions, a longer stem component is necessary. Additonally,\n              various levels of contraint may be employed to increase stability of the joint.</p>',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'nostemtotal1',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.nostemtotal.examples[1],
        imgAlign: 'left',
        text: '<p>Note that the articular aspect of the patella has also been resurfaced and\n                now has a radiolucent polyethylene lining.</p>',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'knee',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.nostemtotal.examples[2],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'pclsparing',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.pclsparing.examples[0],
        imgAlign: 'right',
        text: '<p>Total knee arthroplasties can have varying levels of restricted mobility.\n                The least restricted is the PCL-sparing or nonconstrained arthroplasty, which allow for\n                some rotation and translation of the knee. On the other end of the spectrum, a\n                constrained total knee arthroplasty does not allow for any motion except the minimum\n                necessary hinged flexion and extension.</p>\n                <p>\n                You can distinguish these implants by the amount of femoral bone which is replace by the\n                metallic hardware and the presence of an metal bar connecting the tibial and femoral components.\n                In this case, most of the native femur is preserved.\n              </p>',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'semiconstrained',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.semiconstrained.examples[1],
        imgAlign: 'left',
        text: '<p>At our institution we identify the PCL sacrificing prostheses without\n                radioopaque hinges bridging the tibial and femoral components as semiconstrained.\n                These can be distinguished by the thick\n                femoral component on lateral view, which accomodates\n                a central polyethelyene (radiolucent) tibial post that\n                resists some rotation and varus-valgus motion.\n              </p>',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 25
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'constrained',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.constrained.examples[0],
        imgAlign: 'center',
        text: '<p>The constrained total knee arthroplasty is easily identified by a\n                metallic bar connecting the femoral and tibial components.\n              </p>',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 25
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 25
        }
      }]
    }, {
      title: 'Ankle',
      slides: [{
        id: 'ankle',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].ankle.arthroplasty.examples[0],
        imgAlign: 'center',
        text: '<p>Ankle arthroplasty is an alternative to arthrodesis when the subtalar joint is preserved.\n                This allows for more ankle mobility.</p>',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'ankle2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].ankle.arthroplasty.examples[1],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 95
        }
      }]
    }]
  }, {
    title: 'Hardware Failure',
    subsections: [{
      title: 'Dislocation',
      slides: [{
        id: 'dislocation',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.dislocation.examples[0],
        imgAlign: 'center',
        text: '<p>Two component arthroplasty hardware can dislocate just like the native joints.</p>',
        textLayout: {
          pos: 'top-right',
          bg: true,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'dislocation-right-hip',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.dislocation.examples[1],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-right',
          bg: true,
          w: 95
        }
      }, {
        id: 'dislocation-crosstable',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.dislocation.examples[2],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'dislocation-right-hip2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.dislocation.examples[3],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }]
    }, {
      title: 'Periprosthetic Fracture',
      slides: [{
        id: 'periprostheticfx',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.periprostheticfx.examples[0],
        imgAlign: 'right',
        text: '<p>The bones supporting the hardware may fracture.</p>',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'periprostheticfx2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.periprostheticfx.examples[1],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'periprostheticfx3',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.periprostheticfx.examples[2],
        imgAlign: 'left',
        text: '',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'periprostheticfx4',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.periprostheticfx.examples[3],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-right',
          bg: true,
          w: 95
        }
      }, {
        id: 'periprostheticfx5',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.periprostheticfx.examples[4],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 50
        }
      }]
    }, {
      title: 'Hardware Fracture',
      slides: [{
        id: 'hardwarefx',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.hardwarefx.examples[0],
        imgAlign: 'left',
        text: '<p>Even though it is made of sturdy material,\n                hardware can bend or break under stress.</p>',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 60
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'hardwarefx2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.hardwarefx.examples[1],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'hardwarefx-screws',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.hardwarefx.examples[2],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'hardwarefx4',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.hardwarefx.examples[3],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'hardwarefx5',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.hardwarefx.examples[4],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'hardwarefx6',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.hardwarefx.examples[5],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-right',
          bg: true,
          w: 95
        }
      }]
    }, {
      title: 'Osteolysis/Loosening',
      slides: [{
        id: 'loosening',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[0],
        imgAlign: 'center',
        text: '\n                <p>Loosening is the most common cause for replacement. This can be due to mechanical\n                  stress (wear and tear) or biologic loosening (eg, breakdown of cement).</p>\n\n                <p>Hardware failure often occurs with persistent non-union because of the constant\n                  motion which stresses the hardware.</p>',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[1],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 40
        }
      }, {
        id: 'loosening3',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[3],
        imgAlign: 'right',
        text: '<p>Loosening of a total hip arthroplasty often involves the acetabular component\n                moving inferomedially which causes lateral uncovering of the femoral component.</p>',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'loosening4',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[9],
        imgAlign: 'right',
        text: '<p>Subsidence is a type of loosening wherein the prosthesis sinks further within\n                the bone, typically the femoral component of a total hip replacement.</p>',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening5',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[2],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-left',
          bg: false,
          w: 50
        }
      }, {
        id: 'loosening6',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[4],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening7',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[5],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'loosening8',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[6],
        imgAlign: 'left',
        text: '',
        textLayout: {
          pos: 'bottom-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening9',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[7],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening10',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[8],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'top-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening11',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[10],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-left',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-right',
          bg: true,
          w: 95
        }
      }, {
        id: 'loosening12',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[11],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening13',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[12],
        imgAlign: 'right',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'center-left',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening14',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.particle.examples[0],
        imgAlign: 'right',
        text: '<p>The body may respond to the foreign body (cement or hardware) with inflammation.\n                This eventually results in bony breakdown with large cystic changes/osteolysis.\n                This is called particle disease.</p>',
        textLayout: {
          pos: 'top-left',
          bg: false,
          w: 25
        },
        caption: {
          pos: 'bottom-right',
          bg: false,
          w: 95
        }
      }, {
        id: 'loosening15',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.particle.examples[1],
        imgAlign: 'center',
        text: '<p>Metallosis is a subset of particle disease wherein a pseudotumor is seen due to\n                metal on metal prosthesis (which are now discontinued from the market).</p>',
        textLayout: {
          pos: 'top-right',
          bg: false,
          w: 30
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }]
    }, {
      title: 'Heterotopic ossification',
      slides: [{
        id: 'heterotopic',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.heterotopic.examples[0],
        imgAlign: 'left',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: true,
          w: 95
        }
      }, {
        id: 'heterotopic2',
        img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.heterotopic.examples[1],
        imgAlign: 'center',
        text: '',
        textLayout: {
          pos: 'center-right',
          bg: false,
          w: 40
        },
        caption: {
          pos: 'bottom-left',
          bg: false,
          w: 95
        }
      }]
    }]
  }]
});

/***/ }),

/***/ "LJg8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LY8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__ = __webpack_require__("yfqw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a7dde8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slide_vue__ = __webpack_require__("nYvp");
function injectStyle (ssrContext) {
  __webpack_require__("IaEv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9a7dde8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a7dde8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LuhF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Quiz_js__ = __webpack_require__("Nm5C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MAX_HEIGHT = window.innerHeight - 80 - 20 - 32 - 90;
var QUIZ_SIZE = '' + (MAX_HEIGHT > 756 ? 756 : MAX_HEIGHT) + 'px';
// viewport height minus navbar, margin, space for buttons

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      questions: __WEBPACK_IMPORTED_MODULE_1__Quiz_js__["a" /* default */].questions,
      total: __WEBPACK_IMPORTED_MODULE_1__Quiz_js__["a" /* default */].questions.length,
      current: 0,
      activeQuestion: __WEBPACK_IMPORTED_MODULE_1__Quiz_js__["a" /* default */].questions[0],
      choices: [],
      radioModels: Array(__WEBPACK_IMPORTED_MODULE_1__Quiz_js__["a" /* default */].questions.length).fill(''),
      showResults: false,
      reviewIncorrect: false,
      imageStyle: {
        maxHeight: QUIZ_SIZE
      },
      frameStyle: {
        height: QUIZ_SIZE
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    this.questions = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.shuffle(__WEBPACK_IMPORTED_MODULE_1__Quiz_js__["a" /* default */].questions);
    this.questions = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.questions, function (question) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(question, {
        randomChoices: self.randomize(question.choices)
      });
    });
    this.setQuestion(0);
  },

  computed: {
    numberCorrect: function numberCorrect() {
      var choices = this.choices;
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(choices), function (index) {
        var question = choices[index];
        return question.choices[question.selectedAnswer];
      }).length;
    }
  },
  methods: {
    startReview: function startReview() {
      this.reviewIncorrect = true;
      this.showResults = false;
      this.setQuestion(0);
    },
    radioName: function radioName(index) {
      return 'question_' + index;
    },
    imageUrl: function imageUrl(question) {
      return 'static/imgs/' + question.img;
    },
    stem: function stem(question) {
      return question.stem ? question.stem : 'Which of the following choices best describes the image:';
    },
    advance: function advance() {
      if (this.current + 1 < this.total) {
        this.setQuestion(this.current + 1);
      } else {
        if (confirm('This is the last question. Complete the quiz and view your results?')) {
          this.finish();
        }
      }
    },
    randomize: function randomize(choices) {
      // takes a choices object, which has as keys, answer options, and as
      // values, boolean to represent answer correct or not
      // returns an array of answers choices
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.shuffle(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(choices));
    },
    retreat: function retreat() {
      this.setQuestion(this.current - 1 < 0 ? 0 : this.current - 1);
    },
    select: function select(answer) {
      // do we need to do this... or would the radio models be good enough?
      this.$set(this.choices, this.current, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.activeQuestion, { selectedAnswer: answer }));
      this.advance();
    },
    finish: function finish() {
      this.showResults = true;
    },
    setQuestion: function setQuestion(index) {
      this.current = index;
      this.activeQuestion = this.questions[this.current];
    },
    reset: function reset() {
      this.showResults = false;
      this.choices = [];
      this.reviewIncorrect = false;
      this.radioModels = Array(this.total).fill('');
      this.setQuestion(0);
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7548f222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("GcBZ");
function injectStyle (ssrContext) {
  __webpack_require__("+A8q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7548f222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uikit__ = __webpack_require__("2EC8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uikit_dist_js_uikit_icons__ = __webpack_require__("/zV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uikit_dist_js_uikit_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uikit_dist_js_uikit_icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_css_uikit_mod_min_css__ = __webpack_require__("Q5n1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_css_uikit_mod_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_css_uikit_mod_min_css__);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// loads the Icon plugin
__WEBPACK_IMPORTED_MODULE_4_uikit___default.a.use(__WEBPACK_IMPORTED_MODULE_5_uikit_dist_js_uikit_icons___default.a);



// import UIkit from 'uikit'
// import Icons from 'uikit/dist/js/uikit-icons'

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "Nm5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__ = __webpack_require__("qLo6");


/* harmony default export */ __webpack_exports__["a"] = ({
  questions: [{ // 0
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.dynamic.examples[0].url,
    choices: {
      'Dynamic compression screw': true,
      'Spiral blade': false,
      'Blade-plate': false,
      'Hagie pin': false
    }
  }, { // 1
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.spiral.examples[0].url,
    choices: {
      'Dynamic compression screw': false,
      'Spiral blade': true,
      'Blade-plate': false,
      'Hagie pin': false
    }
  }, { // 2
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.exfix.examples[0].url,
    choices: {
      'External fixation': true,
      'Cast': false,
      'Splint': false,
      'Arthrodesis': false
    }
  }, { // 3
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.imnail.examples[0].url,
    choices: {
      'Intramedullary nail': true,
      'Plate-screw fixation': false,
      'Spiral blade': false,
      'Dyanmic compression screw': false
    }
  }, { // 4
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.spacer.examples[0].url,
    choices: {
      'Articulating antibiotic spacer': true,
      'Unipolar hemi-arthroplasty': false,
      'Bipolar hemi-arthroplasty': false,
      'Total hip arthroplasty': false
    }
  }, { // 5
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.bipolar.examples[0].url,
    choices: {
      'Articulating antibiotic spacer': false,
      'Unipolar hemi-arthroplasty': false,
      'Bipolar hemi-arthroplasty': true,
      'Total hip arthroplasty': false
    }
  }, { // 6
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.total.examples[0].url,
    choices: {
      'Articulating antibiotic spacer': false,
      'Unipolar hemi-arthroplasty': false,
      'Bipolar hemi-arthroplasty': false,
      'Total hip arthroplasty': true
    }
  }, { // 7
    // TODO: change this question to constrained vs non
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].knee.nostemtotal.examples[0].url,
    choices: {
      'No stem total arthroplasty': true,
      'ACL repair': false,
      'Short stem total arthroplasty': false,
      'Unicompartmental arthroplasty': false
    }
  }, { // 8
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].shoulder.reverse.examples[0].url,
    choices: {
      'Reverse total arthroplasty': true,
      'Resurfacing hemiarthroplasty': false,
      'Total arthroplasty': false,
      'Articulating antibiotic spacer': false
    }
  }, { // 9
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].shoulder.total.examples[0].url,
    choices: {
      'Reverse total arthroplasty': false,
      'Resurfacing hemiarthroplasty': false,
      'Total arthroplasty': true,
      'Articulating antibiotic spacer': false
    }
  }, { // 10
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.dislocation.examples[0].url,
    choices: {
      'Dislocation': true,
      'Loosening': false,
      'Hardware fracture': false,
      'Polyethylene wear': false
    }
  }, { // 11
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.wear.examples[1].url,
    choices: {
      'Dislocation': false,
      'Loosening': false,
      'Hardware fracture': false,
      'Polyethylene wear': true
    }
  }, { // 12
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.hardwarefx.examples[0].url,
    choices: {
      'Hardware fracture': true,
      'Heterotopic bone': false,
      'Loosening': false,
      'Dislocation': false
    }
  }, { // 13
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.heterotopic.examples[0].url,
    choices: {
      'Heterotopic bone': true,
      'Periprosthetic fracture': false,
      'Dislocation': false,
      'Arthrofibrosis': false
    }
  }, { // 14
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[9].url,
    choices: {
      'Subsidence': true,
      'Hardware fracture': false,
      'Dislocation': false,
      'Arthrofibrosis': false
    }
  }, { // 15
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.loosening.examples[10].url,
    choices: {
      'Loosening': true,
      'Dislocation': false,
      'Hardware fracture': false,
      'Arthrofibrosis': false
    }
  }, { // 16
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].failure.periprostheticfx.examples[1].url,
    choices: {
      'Periprosthetic fracture': true,
      'Heterotopic bone': false,
      'Dislocation': false,
      'Loosening': false
    }
  }, { // 17
    stem: 'The interlocking screws shown are intended to prevent:',
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.imnail.examples[0].url,
    choices: {
      'Rotation and shortening': true,
      'Loosening': false,
      'Dynamic compression': false,
      'Dislocation': false
    }
  }, { // 18
    stem: 'Bipolar hemiarthroplasty is best used for:',
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].hip.bipolar.examples[0].url,
    choices: {
      'Femoral neck fracture with preserved acetabulum': true,
      'Revision arthroplasty': false,
      'Infected joints': false,
      'Degenerative arthrosis': false
    }
  }, { // 19
    img: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.tension.examples[1].url,
    choices: {
      'Tension wire': true,
      'Cerclage band': false,
      'Percutaneous pin': false,
      'External fixation': false
    }
  }]
});

/***/ }),

/***/ "POcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__ = __webpack_require__("qLo6");
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main',
  props: ['topic', 'subtopic', 'number'],
  data: function data() {
    return {
      activeTab: 0,
      imageStyle: {
        maxHeight: '' + window.innerHeight + 'px',
        maxWidth: '100%', // '' + window.innerWidth + 'px',
        margin: 'auto'
      }
    };
  },

  computed: {
    caption: function caption() {
      return __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */][this.topic][this.subtopic].examples[this.number].caption;
    },
    url: function url() {
      return 'static/imgs/' + __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */][this.topic][this.subtopic].examples[this.number].url;
    }
  }
});

/***/ }),

/***/ "Q5n1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sg9n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TLxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reference_vue__ = __webpack_require__("jBys");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cf72e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reference_vue__ = __webpack_require__("Up5N");
function injectStyle (ssrContext) {
  __webpack_require__("k0kZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01cf72e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reference_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cf72e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reference_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U6Mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__ = __webpack_require__("LuhF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_795305ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__ = __webpack_require__("/5lc");
function injectStyle (ssrContext) {
  __webpack_require__("LJg8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-795305ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_795305ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Up5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello uk-container"},[_c('div',{staticClass:"content-area"},[_c('div',{staticClass:"uk-grid"},[_c('div',{staticClass:"uk-width-1-3"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.hasDesc)?_c('p',[_vm._v(_vm._s(_vm.desc))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.msg))])]),_vm._v(" "),_c('div',{staticClass:"uk-width-2-3"},[_c('ul',{staticClass:"uk-tab uk-margin-small-bottom"},_vm._l((_vm.examples),function(example,index){return _c('li',{class:{ 'uk-active': index == _vm.activeTab }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchExample(index)}}},[_vm._v(_vm._s(_vm.exampleLabel(index)))])])}),0),_vm._v(" "),_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.url}})])])]),_vm._v(" "),_c('div',{staticClass:"sidebar uk-margin-bottom"},[_c('ul',{staticClass:"uk-nav"},[_c('li',{staticClass:"uk-nav-header"},[_vm._v("Fixation")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','arthrodesis'])}}},[_vm._v("Arthrodesis")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','bladeplate'])}}},[_vm._v("Blade Plate")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','cast'])}}},[_vm._v("Cast")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','cerclage_bands'])}}},[_vm._v("Cerclage Bands")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','cerclage'])}}},[_vm._v("Cerclage Wires")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','dynamic'])}}},[_vm._v("Dynamic Compression Screw")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','exfix'])}}},[_vm._v("External Fixation")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','hagie'])}}},[_vm._v("Hagie Pin")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','imnail'])}}},[_vm._v("Intramedullary Nail")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','percutaneous_pin'])}}},[_vm._v("Percutaneous Pin")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','platescrew'])}}},[_vm._v("Plate & Screw")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','screws'])}}},[_vm._v("Screws & Pins")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','spiral'])}}},[_vm._v("Spiral Blade")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','splint'])}}},[_vm._v("Splint")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','syndesmotic'])}}},[_vm._v("Syndesmotic Screw")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['fixation','tension'])}}},[_vm._v("Tension & K Wires")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Ankle")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['ankle','arthroplasty'])}}},[_vm._v("Arthroplasty")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Elbow")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['elbow','arthroplasty'])}}},[_vm._v("Arthroplasty")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Foot")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['foot','duvries'])}}},[_vm._v("DuVires Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['foot','lapiplasty'])}}},[_vm._v("Lapiplasty")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Hip")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['hip','spacer'])}}},[_vm._v("Articulating Antibiotic Spacer")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['hip','unipolar'])}}},[_vm._v("Unipolar Hemi-arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['hip','bipolar'])}}},[_vm._v("Bipolar Hemi-arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['hip','total'])}}},[_vm._v("Total Arthroplasty")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Knee")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','acl'])}}},[_vm._v("ACL Repair")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','femoral'])}}},[_vm._v("Femoral Replacement")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','unicompartmental'])}}},[_vm._v("Unicompartmental Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','nostemtotal'])}}},[_vm._v("Total Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','pclsparing'])}}},[_vm._v("Nonconstrained Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','semiconstrained'])}}},[_vm._v("Semiconstrained Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','constrained'])}}},[_vm._v("Constrained Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['knee','static'])}}},[_vm._v("Static Antibiotic Spacer")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Shoulder")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['shoulder','resurfacing'])}}},[_vm._v("Resurfacing Hemi-arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['shoulder','reverse'])}}},[_vm._v("Reverse Total Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['shoulder','total'])}}},[_vm._v("Total Arthroplasty")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Spine")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['spine','acdf'])}}},[_vm._v("Anterior Fusion")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['spine','postfusion'])}}},[_vm._v("Posterior Fusion")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['spine','bonegraft'])}}},[_vm._v("Bone Graft")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['spine','discarthroplasty'])}}},[_vm._v("Disc Arthroplasty")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['spine','interbodycage'])}}},[_vm._v("Interbody Cage")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['spine','laminoplasty'])}}},[_vm._v("Laminoplasty")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Failure")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','arthrofibrosis'])}}},[_vm._v("Arthrofibrosis")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','dislocation'])}}},[_vm._v("Dislocation")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','hardwarefx'])}}},[_vm._v("Hardware Fracture")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','heterotopic'])}}},[_vm._v("Heterotopic Bone")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','loosening'])}}},[_vm._v("Osteolysis/Loosening")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','particle'])}}},[_vm._v("Particle Disease")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','periprostheticfx'])}}},[_vm._v("Periprosthetic Fracture")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchSubject(['failure','wear'])}}},[_vm._v("Polyethylene Wear")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Lesson__ = __webpack_require__("vX0r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Quiz__ = __webpack_require__("U6Mb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Reference__ = __webpack_require__("TLxc");


// import Main from '@/components/Main'




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'lesson',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Lesson__["a" /* default */]
  }, { path: '/reference',
    name: 'reference',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Reference__["a" /* default */]
  }, {
    path: '/lesson',
    name: 'lesson',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Lesson__["a" /* default */]
  }, {
    path: '/quiz',
    name: 'quiz',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Quiz__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZdJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LessonData_js__ = __webpack_require__("JKZT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slide_vue__ = __webpack_require__("LY8z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LessonImage_vue__ = __webpack_require__("CN7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uikit__ = __webpack_require__("2EC8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uikit__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LessonImage: __WEBPACK_IMPORTED_MODULE_2__LessonImage_vue__["a" /* default */], Slide: __WEBPACK_IMPORTED_MODULE_1__Slide_vue__["a" /* default */] },
  name: 'main',
  data: function data() {
    return {
      currentSlide: 0,
      viewportSize: { w: window.innerWidth, h: window.innerHeight },
      sections: __WEBPACK_IMPORTED_MODULE_0__LessonData_js__["a" /* default */].sections,
      slides: this.flattenSlides(__WEBPACK_IMPORTED_MODULE_0__LessonData_js__["a" /* default */].sections)
    };
  },

  computed: {
    prevSlide: function prevSlide() {
      // at the very beginning, prior to slides loading, set some defaults
      if (this.currentSlide === 0) {
        return '#' + this.slides[this.currentSlide].id;
      } else {
        return '#' + this.slides[this.currentSlide - 1].id;
      }
    },
    nextSlide: function nextSlide() {
      if (this.currentSlide === this.slides.length - 1) {
        return '#' + this.slides[this.currentSlide].id;
      } else {
        return '#' + this.slides[this.currentSlide + 1].id;
      }
    }
  },
  methods: {
    onScroll: function onScroll(evt) {
      var numSlides = this.slides.length;
      // find the closest slide and make it current
      var prevY = -1000000; // really far away
      var y = 0; // will be overwritten immediately
      for (var i = 0; i < numSlides; i++) {
        var elem = document.getElementById(this.slides[i].id);
        y = elem.getBoundingClientRect().top;
        if (y > 0) {
          this.determineClosest(i - 1, prevY, i, y);
          return;
        }
        prevY = y;
      }
      // we reached the end and never found the inflection point
      // check last 2
      this.determineClosest(numSlides - 2, prevY, numSlides - 1, y);
    },
    determineClosest: function determineClosest(firstIndex, firstY, secondIndex, secondY) {
      // this function sets the currentSlide based on which slide is the dominant
      // one in the viewport
      if (firstIndex < 0) {
        // if we are at the first slide or there is only one slide
        // then the previous slide might not exist
        this.currentSlide = secondIndex;
      } else {
        // otherwise, determine which absolute value is lowest
        if (firstY * firstY < secondY * secondY) {
          this.currentSlide = firstIndex;
        } else {
          this.currentSlide = secondIndex;
        }
      }
    },
    flattenSlides: function flattenSlides(sections) {
      // flatten slides to a single list
      var sectionSlideList = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(sections, function (section) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(section.subsections, function (subsection) {
          return subsection.slides;
        });
      });
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flattenDeep(sectionSlideList);
    }
  },
  mounted: function mounted() {
    var self = this;
    // percolate viewport size down to slides
    window.addEventListener('resize', function () {
      self.viewportSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      self.onScroll();
    });

    window.addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(this.onScroll, 50));

    // add the uk-sticky to the components after a delay to give page time to layout
    // it seems at least in IE or when loading slowly, the stickies do not know how
    // to position themselves unless the box heights are already defined
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(document.querySelectorAll('.sticky-header'), function (elem) {
        __WEBPACK_IMPORTED_MODULE_4_uikit___default.a.sticky(elem, { bottom: true });
      });
      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(document.querySelectorAll('.sticky-subheader'), function (elem) {
        __WEBPACK_IMPORTED_MODULE_4_uikit___default.a.sticky(elem, { bottom: true, offset: 40 });
      });
    }, 2000);
  }
});

/***/ }),

/***/ "atck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-container uk-article uk-margin-large-bottom"},[_c('h1',{staticClass:"uk-article-title"},[_vm._v("Guided Tour")]),_vm._v(" "),_c('h2',{attrs:{"id":"introduction"}},[_vm._v("Introduction")]),_vm._v(" "),_c('div',{staticClass:"uk-margin-large-bottom"},[_c('p',[_vm._v("This module is designed to help familiarize the beginning radiology resident with\n    the basics of orthopedic hardware types and complications on plain radiography.")]),_vm._v(" "),_c('p',[_vm._v("Once you have completed the module you can "),_c('router-link',{attrs:{"to":"quiz"}},[_vm._v("quiz")]),_vm._v(" yourself on your understanding or\n    use the "),_c('router-link',{attrs:{"to":"reference"}},[_vm._v("library")]),_vm._v(" to quickly review topics of interest.")],1),_vm._v(" "),_c('p',[_vm._v("We will first discuss the basics and types of fracture fixation, then joint replacement,\n    and finally failure modes for these types of hardware to look out for on follow up films.")])]),_vm._v(" "),_vm._l((_vm.sections),function(section){return _c('div',[_c('h2',{staticClass:"sticky-header"},[_vm._v(_vm._s(section.title))]),_vm._v(" "),(section.text)?_c('div',{domProps:{"innerHTML":_vm._s(section.text)}}):_vm._e(),_vm._v(" "),_vm._l((section.subsections),function(subsection){return _c('div',[(subsection.title)?_c('h3',{staticClass:"sticky-subheader"},[_vm._v(_vm._s(subsection.title))]):_vm._e(),_vm._v(" "),_vm._l((subsection.slides),function(slide){return _c('Slide',{key:slide.id,attrs:{"size":_vm.viewportSize,"slideData":slide}})})],2)})],2)}),_vm._v(" "),_c('H2',{attrs:{"id":"conclusion"}},[_vm._v("Conclusion")]),_vm._v(" "),_c('p',[_vm._v("Now you have an idea of what to look for when assessing a postoperative orthopedic\n    patient. Hopefully this module will help facilitate a more precise description of\n    your findings in the future. To test your knowledge, check out the\n    "),_c('router-link',{attrs:{"to":"quiz"}},[_vm._v("quiz")]),_vm._v(". Additionally,\n    a "),_c('router-link',{attrs:{"to":"reference"}},[_vm._v("reference")]),_vm._v(" section has been provided for quick\n    look-up of the images used in this module.")],1),_vm._v(" "),_c('h2',[_vm._v("References")]),_vm._v(" "),_c('p',[_vm._v("Taljanovic, M, et al. “Fracture Fixation.” Radiographics 2003, 23:6.")]),_vm._v(" "),_c('p',[_vm._v("Taljanovic, M. et al. “Joint Arthroplasties and Prostheses.” Radiographics 2003, 23:5.")]),_vm._v(" "),_c('p',[_vm._v("Slone, RM, et al. “Orthopedic Fixation Devices.” Radiographics 1991, 11:5.")]),_vm._v(" "),_c('p',[_vm._v("Petscavage, JM, Ha, AS and Chew FS. “Imaging Assessment of the Postoperative Arthritic Wrist.” Radiographics 2011, 31:6.")]),_vm._v(" "),_c('div',{staticClass:"slide-nav"},[_c('div',{staticClass:"slide-nav-content"},[_vm._m(0),_vm._v(" "),_c('a',{attrs:{"id":"scroll-prev","href":_vm.prevSlide,"uk-scroll":""}},[_c('button',{staticClass:"uk-button uk-button-default blackbg"},[_vm._v("Previous")])]),_vm._v("   "+_vm._s(_vm.currentSlide + 1)+" / "+_vm._s(_vm.slides.length)+"  \n      "),_c('a',{attrs:{"id":"scroll-next","href":_vm.nextSlide,"uk-scroll":""}},[_c('button',{staticClass:"uk-button uk-button-default blackbg"},[_vm._v("Next")])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-inline uk-text-left"},[_c('button',{staticClass:"uk-button uk-button-default blackbg",attrs:{"type":"button"}},[_vm._v("Menu")]),_vm._v(" "),_c('div',{attrs:{"uk-dropdown":"pos: top-center"}},[_c('div',{staticClass:"uk-dropdown-grid uk-width-large uk-child-width-1-2",attrs:{"uk-grid":""}},[_c('div',[_c('ul',{staticClass:"uk-nav uk-dropdown-nav"},[_c('li',{staticClass:"uk-nav-header"},[_c('a',{attrs:{"href":"#introduction","uk-scroll":""}},[_vm._v("Introduction")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Fixation")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#cast","uk-scroll":""}},[_vm._v("Conservative Measures")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#platescrew","uk-scroll":""}},[_vm._v("Internal Fixation")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_c('a',{attrs:{"href":"#arthrodesis","uk-scroll":""}},[_vm._v("Arthrodesis")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Arthroplasty")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#resurfacing","uk-scroll":""}},[_vm._v("Shoulder")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#hip","uk-scroll":""}},[_vm._v("Hip")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#unicompartmental","uk-scroll":""}},[_vm._v("Knee")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#ankle","uk-scroll":""}},[_vm._v("Ankle")])])])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"uk-nav uk-dropdown-nav"},[_c('li',{staticClass:"uk-nav-header"},[_vm._v("Hardware Failure")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#dislocation","uk-scroll":""}},[_vm._v("Dislocation")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#periprostheticfx","uk-scroll":""}},[_vm._v("Periprosthetic Fracture")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#hardwarefx","uk-scroll":""}},[_vm._v("Hardware Fracture")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#loosening","uk-scroll":""}},[_vm._v("Osteolysis/Loosening")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#heterotopic","uk-scroll":""}},[_vm._v("Heterotopic Bone")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_c('a',{attrs:{"href":"#conclusion","uk-scroll":""}},[_vm._v("Conclusion")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_c('a',{attrs:{"href":"#/quiz"}},[_vm._v("→ Quiz")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_c('a',{attrs:{"href":"#/reference"}},[_vm._v("→ Library")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jBys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__ = __webpack_require__("qLo6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main',
  data: function data() {
    return {
      activeTab: 0,
      imageStyle: {
        maxHeight: '' + (window.innerHeight - 80 - 20 - 32) + 'px' // viewport height minus navbar, margin, and tabs
      },
      examples: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.percutaneous_pin.examples,
      title: __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */].fixation.percutaneous_pin.title,
      desc: undefined
    };
  },

  computed: {
    msg: function msg() {
      return this.examples[this.activeTab].caption;
    },
    url: function url() {
      return 'static/imgs/' + this.examples[this.activeTab].url;
    },
    hasDesc: function hasDesc() {
      return this.desc !== undefined;
    }
  },
  methods: {
    exampleLabel: function exampleLabel(index) {
      var prefix = this.examples.length < 5 ? 'Example ' : '';
      return prefix + (index + 1);
    },
    switchExample: function switchExample(index) {
      this.activeTab = index;
    },
    switchSubject: function switchSubject(newExamples) {
      this.examples = __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */][newExamples[0]][newExamples[1]].examples;
      this.title = __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */][newExamples[0]][newExamples[1]].title;
      this.desc = __WEBPACK_IMPORTED_MODULE_0__ImageMeta_js__["a" /* default */][newExamples[0]][newExamples[1]].description;
      this.activeTab = 0;
    }
  }
});

/***/ }),

/***/ "k0kZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nYvp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-margin uk-inline",class:_vm.layoutImg(_vm.slideData.imgAlign),style:(_vm.slideStyle),attrs:{"id":_vm.slideId}},[_c('img',{style:(_vm.imgStyle),attrs:{"src":_vm.url(_vm.slideData.img)}}),_vm._v(" "),_c('div',{staticClass:"uk-overlay uk-text-left",class:_vm.layoutClass(_vm.slideData.textLayout),style:(_vm.layoutStyle(_vm.slideData.textLayout))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.slideData.text)}})]),_vm._v(" "),_c('div',{staticClass:"uk-overlay uk-text-left",class:_vm.layoutClass(_vm.slideData.caption),style:(_vm.layoutStyle(_vm.slideData.caption))},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.slideData.img.caption)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qLo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// when updating this file, keep in mind that the examples images for each
// group are ordered, and referenced by index elsewhere in the application (noteably, the quiz)
// thus if you are adding to an existing set willy-nilly, add to the end of the list

/* harmony default export */ __webpack_exports__["a"] = ({
  fixation: {
    arthrodesis: {
      title: 'Arthrodesis',
      examples: [{
        url: 'wrist.jpg',
        caption: 'Four corner arthrodesis of the hamate, lunate, capitate, and triquetrum as well as scaphoidectomy.'
      }, {
        url: 'hindfoot.jpg',
        caption: 'Triple arthrodesis of the subtalar, calcaneocuboid, and talonavicular joints.'
      }, {
        url: 'tibiotalocalc.PNG',
        caption: 'Tibiotalocalcaneal arthrodesis.'
      }, {
        url: 'tibiotalocalc2.PNG',
        caption: 'Tibiotalocalcaneal arthrodesis and distal fibular resection.'
      }, {
        url: 'tibiotalocalc3.PNG',
        caption: 'Tibiotalocalcaneal arthrodesis and distal fibular resection.'
      }, {
        url: 'wristarthrodesis.PNG',
        caption: 'Wrist arthrodesis.'
      }]
    },
    bladeplate: {
      title: 'Blate Plate and Screw',
      examples: [{
        url: 'bladescrew.jpg',
        caption: 'Bilateral blade plate-screw fixation of subtrochanteric osteostomies or fractures.'
      }]
    },
    cast: {
      title: 'Cast',
      examples: [{
        url: 'cast.jpg',
        caption: 'Cast material shown as well as percutaneous pinning of a complex elbow fracture'
      }]
    },
    cerclage: {
      title: 'Cerclage Wires',
      examples: [{
        url: 'cerclage.jpg',
        caption: 'Left total hip arthroplasty with plate-screw fixation of the proximal femur with cerclage wire reinforcement.'
      }]
    },
    cerclage_bands: {
      title: 'Cerclage Bands',
      examples: [{
        url: 'cerclageband.PNG',
        caption: 'Left total hip arthroplasty with cerclage band reinforcement at the proximal femur.'
      }, {
        url: 'cerclageband2.PNG',
        caption: 'Right hip arthroplasty long femoral stem with cerclage bands (3) for reinforcement.'
      }]
    },
    dynamic: {
      title: 'Dynamic Compression Screw',
      examples: [{
        url: 'dynamiccompression.jpg',
        caption: 'Dynamic compression screw through an intertrochanteric fracture of the left femur.'
      }]
    },
    exfix: {
      title: 'External Fixation',
      examples: [{
        url: 'exfix.jpg',
        caption: 'External fixation is a temporary strategy before internal fixation.'
      }]
    },
    hagie: {
      title: 'Hagie Pin',
      examples: [{
        url: 'hagiepin.jpg',
        caption: 'Hagie pin through a clavicular fracture.'
      }]
    },
    imnail: {
      title: 'Intramedullary Nail',
      examples: [{
        url: 'imnail.jpg',
        caption: 'Intramedullary nail with interlocking screws in the femur, with periosteal reaction and loosening at the proximal screw.'
      }, {
        url: 'imnail2.jpg',
        caption: 'Intramedullary nail with interlocking screws for a complex tibia and fibula fracture.'
      }]
    },
    percutaneous_pin: {
      title: 'Percutaneous Pin',
      examples: [{
        url: 'percpin.jpg',
        caption: 'Percutaneous pinning of a complex elbow fracture.'
      }, {
        url: 'percpin2.png',
        caption: 'Percutaneous pinning following osteotomy for hammertoe correction.'
      }]
    },
    platescrew: {
      title: 'Plate and Screw',
      examples: [{
        url: 'platescrew.jpg',
        caption: 'Total knee arthroplasty with plate-screw fixation of the proximal tibia.'
      }]
    },
    screws: {
      title: 'Screws and Pins',
      examples: [{
        url: 'screw.jpg',
        caption: 'Screw through the fifth metatarsal for a Jones fracture.'
      }, {
        url: 'screw2.jpg',
        caption: 'Screw fixation of a medial malleolar fracture as well as screws and pins fixing a talar fracture.'
      }]
    },
    spiral: {
      title: 'Spiral Blade',
      examples: [{
        url: 'spiralblade.jpg',
        caption: 'Spiral blade with intramedullary nail fixation of a intertrochanteric femur fracture. This provides dynamic compression.'
      }]
    },
    splint: {
      title: 'Splint',
      examples: [{
        url: 'splint.jpg',
        caption: 'Splint material shown. Used for initial stabilization, is adjustable, and allows for swelling.'
      }]
    },
    syndesmotic: {
      title: 'Syndesmotic Screw',
      examples: [{
        url: 'syndesmoticscrew.png',
        caption: 'Plate-screw fixation of the distal fibula with syndesmotic screw.'
      }]
    },
    tension: {
      title: 'Tension Wires and K-Wires',
      examples: [{
        url: 'kwire.jpg',
        caption: 'Tension wire (thinner wire) and K-wire (thicker wire/pin) fixation of a displaced proximal ulna fracture. Plate-screw fixation of the proximal radius.'
      }, {
        url: 'tensionwire.jpg',
        caption: 'Tension wire and K-wire fixation of a displaced patella fracture.'
      }]
    }
  },
  ankle: {
    arthroplasty: {
      title: 'Ankle Arthroplasty',
      examples: [{
        url: 'totalankleap.jpg',
        caption: 'Frontal view of an ankle athroplasty.'
      }, {
        url: 'totalanklelat.jpg',
        caption: 'Lateral view of an ankle athroplasty.'
      }]
    }
  },
  elbow: {
    arthroplasty: {
      title: 'Elbow Arthroplasty',
      examples: [{
        url: 'totalelbow.PNG',
        caption: 'Total elbow arthroplasty with distal humeral replacement.'
      }, {
        url: 'totalelbow2.PNG',
        caption: 'Total elbow arthroplasty.'
      }, {
        url: 'totalelbow4.PNG',
        caption: 'Total elbow arthroplasty with distal humeral and proximal ulnar replacement.'
      }]
    }
  },
  foot: {
    duvries: {
      title: 'DuVries Arthroplasty',
      description: 'Proximal phalangeal head resection and fixation of the proximal interphalangeal joint.',
      examples: [{
        url: 'duvries.PNG',
        caption: 'DuVries Arthroplasty of the 2nd 3rd and 5th toes.'
      }, {
        url: 'duvries2.PNG',
        caption: 'DuVries Arthroplasty of the 2-4 toes.'
      }, {
        url: 'duvries3.PNG',
        caption: 'DuVries Arthroplasty of the 2-5 toes.'
      }]
    },
    lapiplasty: {
      title: 'Lapiplasty',
      description: '\n        Lapiplasty or Lapidus bunionectomy involves an osteotomy at the base of\n        the first metatarsal and realignment and fixation of the first tarsometatarsal joint.\n      ',
      examples: [{
        url: 'lapiplasty.PNG',
        caption: 'AP view of lapiplasty fixation hardware.'
      }, {
        url: 'lapiplasty2.PNG',
        caption: 'Lateral view of lapiplasty fixation hardware.'
      }, {
        url: 'lapiplasty3.PNG',
        caption: 'AP view of lapiplasty fixation hardware.'
      }]
    }
  },
  hip: {
    spacer: {
      title: 'Articulating Antibiotic Spacer',
      examples: [{
        url: 'spacer.jpg',
        caption: 'An articulating antibiotic spacer with prominent acetabular and femoral cement as well as heterotopic bone formation.'
      }]
    },
    unipolar: {
      title: 'Unipolar Hip Hemi-arthroplasty',
      examples: [{
        url: 'unipolarhip.png',
        caption: 'Unipolar hip hemi-arthroplasty is shown. Note the preserved native acetabulum.'
      }, {
        url: 'unipolarhip2.png',
        caption: 'Unipolar hip hemi-arthroplasty is shown. Note the preserved native acetabulum.'
      }]
    },
    bipolar: {
      title: 'Bipolar Hip Hemi-arthroplasty',
      examples: [{
        url: 'bipolarhip.jpg',
        caption: 'A bipolar hip hemi-arthroplasty. The native acetabulum is preserved.'
      }, {
        url: 'bipolarhip4.png',
        caption: 'A bipolar hip hemi-arthroplasty. The native acetabulum is preserved.'
      }]
    },
    total: {
      title: 'Total Hip Arthroplasty',
      examples: [{
        url: 'totalhip.jpg',
        caption: 'Noncemented right total hip arthroplasty. Note the acetabular component with screw.'
      }, {
        url: 'djdhip2.png',
        caption: 'Noncemented left total hip arthroplasty. Note the acetabular component.'
      }]
    },
    cemented: {
      title: 'Cemented Total Hip Arthroplasty',
      examples: [{
        url: '',
        caption: ''
      }]
    }
  },
  knee: {
    acl: {
      title: 'ACL Repair',
      examples: [{
        url: 'acl3.png',
        caption: 'Frontal view of anterior cruciate ligament repair.'
      }, {
        url: 'acl4.png',
        caption: 'Lateral view of anterior cruciate ligament repair.'
      }]
    },
    femoral: {
      title: 'Distal Femoral Replacement',
      examples: [{
        url: 'distalfemoral.PNG',
        caption: 'Lateral view of distal femoral and proximal tibial replacement with cerclage wire support.'
      }]
    },
    unicompartmental: {
      title: 'Unicompartmental Knee Arthroplasty',
      examples: [{
        url: 'unicompartmentalknee.jpg',
        caption: 'Frontal view of medial compartment unicompartmental knee arthroplasty.'
      }, {
        url: 'unicompartmentalknee2.jpg',
        caption: 'Lateral view of medial compartment unicompartmental knee arthroplasty.'
      }]
    },
    nostemtotal: {
      title: 'Total Knee Arthroplasty',
      examples: [{
        url: 'totalkneenostem.jpg',
        caption: 'Frontal view of a total knee arthroplasty.'
      }, {
        url: 'totalkneenostemlat.jpg',
        caption: 'Lateral view of a total knee arthroplasty.'
      }, {
        url: 'totalkneeshort.jpg',
        caption: 'Short stem total knee arthroplasty.'
      }]
    },
    static: {
      title: 'Static Antibiotic Spacer',
      examples: [{
        url: 'staticknee.PNG',
        caption: 'Lateral view of a static antibiotic spacer and cement.'
      }]
    },
    pclsparing: {
      title: 'PCL Sparing Total Knee Arthroplasty',
      description: 'The thin metallic femoral component seen on the lateral view is the key to identification.',
      examples: [{
        url: 'pclsparing0.PNG',
        caption: 'Frontal view of a nonconstrained PCL sparing total knee arthroplasty.'
      }, {
        url: 'pclsparing_lat0.PNG',
        caption: 'Lateral view of a nonconstrained PCL sparing total knee arthroplasty with patellar resurfacing.'
      }]
    },
    constrained: {
      title: 'Constrained Total Knee Arthroplasty',
      examples: [{
        url: 'constrained_ap.PNG',
        caption: 'Frontal view of a constrained total knee arthroplasty with long femoral and tibial stems.'
      }, {
        url: 'constrained_lat.PNG',
        caption: 'Lateral view of a constrained total knee arthroplasty with long femoral and tibial stems.'
      }]
    },
    semiconstrained: {
      title: 'Semiconstrained Total Knee Arthroplasty',
      description: 'The thick metallic femoral component seen on the lateral view is the key to identification.',
      examples: [{
        url: 'semiconstrained_ap.PNG',
        caption: 'Frontal view of a semiconstrained total knee arthroplasty.'
      }, {
        url: 'semiconstrained_lat.PNG',
        caption: 'Lateral view of a semiconstrained total knee arthroplasty.'
      }]
    }
  },
  shoulder: {
    resurfacing: {
      title: 'Resurfacing Hemi-arthroplasty',
      examples: [{
        url: 'shoulderhemi.jpg',
        caption: 'Shoulder resurfacing hemi-arthroplasty is shown. The glenoid is not replaced.'
      }]
    },
    total: {
      title: 'Total Shoulder Arthroplasty',
      examples: [{
        url: 'totalshoulder.jpg',
        caption: 'Conventional total shoulder arhtroplasty. A metallic marker at the glenoid indicates replacement.'
      }, {
        url: 'totalshoulder2.jpg',
        caption: 'Axillary view of total shoulder arthroplasty.'
      }]
    },
    reverse: {
      title: 'Reverse Total Shoulder Arthroplasty',
      examples: [{
        url: 'shoulderreverse.jpg',
        caption: 'A reverse total shoulder arthroplasty uses the deltoid for action and is thus good if there is rotator cuff injury.'
      }]
    }
  },
  spine: {
    acdf: {
      title: 'Anterior Cervical Discectomy and Fusion',
      examples: [{
        url: 'acdf.PNG',
        caption: 'Lateral view of C4-C7 anterior fusion with interbody cages.'
      }, {
        url: 'acdf2.PNG',
        caption: 'Frontal view of C4-C7 anterior fusion with interbody cages.'
      }, {
        url: 'acdf3.PNG',
        caption: 'Anterior cervical discectomy and fusion at C4-C6.'
      }]
    },
    bonegraft: {
      title: 'Bone Graft',
      examples: [{
        url: 'bonegraft.PNG',
        caption: 'Frontal view of posterior and anterior spinal fusion with posterolateral bone graft (arrowheads), instrumentation, interbody cages, and laminectomy.'
      }, {
        url: 'interbodybone.PNG',
        caption: 'L5-S1 posterior spinal fusion with instrumentation and interbody bone graft (arrow)'
      }]
    },
    discarthroplasty: {
      title: 'Disc Arthroplasty',
      examples: [{
        url: 'discarthroplasty.PNG',
        caption: 'C5-C6 disc arthroplasty'
      }, {
        url: 'discarthroplasty2.PNG',
        caption: 'C5-C6 disc arthroplasty'
      }]
    },
    interbodycage: {
      title: 'Interbody Cage',
      examples: [{
        url: 'interbodycage.PNG',
        caption: 'L3-S1 posterior spinal fusion with instrumentation and L4-L5 interbody cage (radiodense marker annotated with arrow)'
      }]
    },
    laminoplasty: {
      title: 'Laminoplasty',
      examples: [{
        url: 'laminoplasty.PNG',
        caption: 'Frontal view of C3-C7 left laminoplasty.'
      }, {
        url: 'laminoplasty2.PNG',
        caption: 'Lateral view of C3-C7 laminoplasty.'
      }]
    },
    postfusion: {
      title: 'Posterior Spinal Fusion with Instrumentation',
      examples: [{
        url: 'postfusion.PNG',
        caption: 'Lateral view of T11-L3 posterior spinal fusion with instrumentation for an L1 vertebral body compression fracture.'
      }, {
        url: 'postfusion2.PNG',
        caption: 'Frontal view of T11-L3 posterior spinal fusion with instrumentation for an L1 vertebral body compression fracture.'
      }]
    }
  },
  failure: {
    acl: {
      // TODO: tunnel to wide: aclfail3.png, aclfail4.png
    },
    arthrofibrosis: {
      title: 'Arthrofibrosis',
      examples: [{
        url: 'aclmri1.jpg',
        caption: 'T1 image of arhtrofibrosis, a fibrotic mass at the tibial insertion of the reconstruction which can limit mobility.'
      }, {
        url: 'aclmri2.jpg',
        caption: 'T2 image of arhtrofibrosis, a fibrotic mass at the tibial insertion of the reconstruction which can limit mobility.'
      }]
    },
    dislocation: {
      title: 'Dislocation',
      examples: [{
        url: 'shoulderdislocation.jpg',
        caption: 'Dislocated right reverse total shoulder arthroplasty.'
      }, {
        url: 'hipdislocation.jpg',
        caption: 'Dislocated right total hip arthroplasty.'
      }, {
        url: 'hipdislocation2.jpg',
        caption: 'Dislocated total hip arthroplasty.'
      }, {
        url: 'hipdislocation3.jpg',
        caption: 'Dislocated right total hip arthroplasty.'
      }]
    },
    hardwarefx: {
      title: 'Hardware Fracture',
      examples: [{
        url: 'anklefx.jpg',
        caption: 'Frontal view of fractured tibial plate.'
      }, {
        url: 'anklefx2.jpg',
        caption: 'Lateral view of fractured tibial plate.'
      }, {
        url: 'spinefx.jpg',
        caption: 'Multiple fractured pedicle screws.'
      }, {
        url: 'spinefx2.jpg',
        caption: 'Multiple fractured pedicle screws.'
      }, {
        url: 'femurfx.jpg',
        caption: 'Fractured screws within the femoral diaphysis.'
      }, {
        url: 'femurfx2.jpg',
        caption: 'Fracture of the neck of the femoral component of a right total hip arthroplasty.'
      }]
    },
    heterotopic: {
      title: 'Heterotopic Bone',
      examples: [{
        url: 'heterotopic.jpg',
        caption: 'Heterotopic bone formation medial and lateral to the proximal femur in patient with articulating antibiotic spacer.'
      }, {
        url: 'heterotopic2.jpg',
        caption: 'Heterotopic bone formation lateral to the hip.'
      }]
    },
    loosening: {
      title: 'Osteolysis/Loosening',
      examples: [{
        url: 'wristplatescrew.jpg',
        caption: 'Loosening of the third distal screw.'
      }, {
        url: 'alignment2.jpg',
        caption: 'Loosening of all of the proximal screws and incomplete healing.'
      }, {
        url: 'alignmentspine.jpg',
        caption: 'Loosening of one of the T12 pedicle screws (the screw with more prominent threads).'
      }, {
        url: 'hiploosening.jpg', // 3
        caption: 'Lateral uncovering of the prosthetic femoral head due to acetabular component loosening.'
      }, {
        url: 'shoulderloosening.jpg',
        caption: 'Loosening along the humeral stem.'
      }, {
        url: 'shoulderloosening2.jpg',
        caption: 'Loosening along the humeral stem with anterior dislocation.'
      }, {
        url: 'spinefail2.jpg', // before image is spinefail.jpg
        caption: 'Loosening of the interbody cage.'
      }, {
        url: 'radiusloosening2.png', // before image is radiusloosening.png; 7
        caption: 'Loosening of the radial head prosthesis.'
      }, {
        url: 'kneeloosening3.jpg',
        caption: 'Loosening of the tibial plate.'
      }, {
        url: 'hipfail.jpg', // 9
        caption: 'Subsidence of the femoral component due to loosening.'
      }, {
        url: 'hipfail3.jpg', // before image is hipfail2.jpg
        caption: 'Loosening of the acetabular component.'
      }, {
        url: 'aclfail.png',
        caption: 'ACL tendon anchor within the femoral tunnel.'
      }, {
        url: 'aclfail2.png',
        caption: 'ACL tendon anchor within the femoral tunnel.'
      }]
    },
    particle: {
      title: 'Particle Disease',
      examples: [{
        url: 'particledz.jpg',
        caption: 'Extensive loosening along the femoral stem and acetabular component.'
      }, {
        url: 'metallosis.jpg',
        caption: 'T1-weighted MRI showing pseudotumor (black, round area superior to left hip) due to susceptibility artifact from small metalic fragments.'
      }, {
        url: 'metallosis2.jpg',
        caption: 'Metallosis with extensive metallic debris in the joint space and soft tissue around a total hip arthroplasty.'
      }]
    },
    periprostheticfx: {
      title: 'Periprosthetic Fracture',
      examples: [{
        url: 'kneefx.jpg',
        caption: 'Periprosthetic adjacent to the tibial plate, status post plate-screw fixation.'
      }, {
        url: 'kneefx2.jpg',
        caption: 'Acute periprosthetic fracture of the distal femur.'
      }, {
        url: 'kneefx2lat.jpg',
        caption: 'Acute periprosthetic fracture of the distal femur.'
      }, {
        url: 'hipfx.jpg',
        caption: 'Remote periproshetic fracture at the distal femoral stem component.'
      }, {
        url: 'hipfx2.jpg',
        caption: 'Remote periproshetic fracture at the distal femoral stem component.'
      }]
    },
    wear: {
      title: 'Polyethylene Wear',
      examples: [{
        url: 'wear_pre.JPG',
        caption: 'Normal appearance of total hip arthroplasty with the prosthetic femoral head component centered in the acetabular cup.'
      }, {
        url: 'wear_post.JPG',
        caption: 'Eccentric position of the prosthetic femoral head within the acetabular cup due to polyethylene wear.'
      }]
    }
  }
});

/***/ }),

/***/ "vX0r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lesson_vue__ = __webpack_require__("ZdJS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4a04ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lesson_vue__ = __webpack_require__("atck");
function injectStyle (ssrContext) {
  __webpack_require__("zXKR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d4a04ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lesson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4a04ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lesson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "yfqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['size', 'index', 'slideData'],
  data: function data() {
    return {
      slideId: this.slideData.id
    };
  },
  mounted: function mounted() {},

  computed: {
    slideStyle: function slideStyle() {
      return {
        height: '' + (this.size.h - 0) + 'px',
        width: '100%',
        backgroundColor: 'black'
      };
    },
    imgStyle: function imgStyle() {
      return {
        maxHeight: '' + this.size.h + 'px',
        maxWidth: '100%'
      };
    },
    captionClass: function captionClass() {},
    captionStyle: function captionStyle() {}
  },
  methods: {
    url: function url(img) {
      return 'static/imgs/' + img.url;
    },
    layoutImg: function layoutImg(elem) {
      return {
        'uk-text-center': elem === undefined || elem === 'center',
        'uk-text-left': elem === 'left',
        'uk-text-right': elem === 'right'
      };
    },
    layoutClass: function layoutClass(elem) {
      return {
        'uk-position-center-right': elem.pos === 'center-right',
        'uk-position-center-left': elem.pos === 'center-left',
        'uk-position-center': elem.pos === 'center',
        'uk-position-top-right': elem.pos === 'top-right',
        'uk-position-top-left': elem.pos === 'top-left',
        'uk-position-bottom-left': elem.pos === 'bottom-left',
        'uk-position-bottom-right': elem.pos === 'bottom-right',
        'pad-bottom': elem.pos === 'bottom-left' || elem.pos === 'bottom-right',
        'pad-top': elem.pos === 'top-left',
        'uk-overlay-primary': elem.bg === true
      };
    },
    layoutStyle: function layoutStyle(elem) {
      return {
        'maxWidth': elem.w + '%'
      };
    }
  }
});

/***/ }),

/***/ "zXKR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4e1e7b86375a474a797b.js